var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px',
    borderWidth: _vm.borderWidth + 'px',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }